import { z, isoZ } from 'my-zod'
import { enumOptionsToObject } from '../../internal'

/**
 * @file Any update to `CustomerOrderChangeLogOperationEnum`, ensure you update
 * operations in customerOrderChangeLog table.
 */

export const CustomerOrderChangeLogOperationEnum = z.enum([
  'CreateOrder',
  'RiderAdded',
  'RiderRemoved',
  'PrimaryRiderSwapped',
  'RescheduleOrder',
  'VehiclesChanged',
  'RideInsuranceChanged',
  'WaiverCompleted',
  'WaiverRemoved',
  'CheckOut',
  'CheckIn',
  'VoidCheckOut',
  'CancelOrder',
  'CardCharged',
  'CardRefunded',
  'PendingRefund',
  'CashPayment',
  'CashRefunded',
  'CheckPayment',
  'GiftCardPayment',
  'GiftCardRefunded',
  'AddOnProductsChanged',
  'CardAuthorized',
  'CardAuthorizationCancelled',
  'ReviewCompleted',
  'CardAddedToFile'
])

export type CustomerOrderChangeLogOperationEnum = z.infer<typeof CustomerOrderChangeLogOperationEnum>

export const CustomerOrderChangeLogOperationOptions = Object.values(CustomerOrderChangeLogOperationEnum.Values)
export const CustomerOrderChangeLogOperations = enumOptionsToObject(CustomerOrderChangeLogOperationOptions)

export const customerOrderChangeLogModel = z.object({
  id: z.string().uuid(),
  topic: z.string(),
  profileId: z.number(),
  operation: CustomerOrderChangeLogOperationEnum,
  change: z.string(),
  createdDate: isoZ.instant()
})

export type customerOrderChangeLogModel = z.infer<typeof customerOrderChangeLogModel>
